import { AUTHORIZATION_KEY, TENANT_NAME_KEY, TENANT_TYPE_KEY } from '../consts/auth';
export class StorageUtil {

  public static clear() {
    localStorage.removeItem(AUTHORIZATION_KEY);
  }

  public static getToken(): string {
    return localStorage.getItem(AUTHORIZATION_KEY);
  }

  public static cleanTenantName() {
    localStorage.removeItem(TENANT_NAME_KEY);
  }

  public static getTenantName(): string {
    return localStorage.getItem(TENANT_NAME_KEY);
  }

  public static setTenantName(name) {
    localStorage.setItem(TENANT_NAME_KEY, name);
  }

  public static cleanTenantType() {
    localStorage.removeItem(TENANT_TYPE_KEY);
  }

  public static getTenantType(): string {
    return localStorage.getItem(TENANT_TYPE_KEY);
  }

  public static setTenantType(name) {
    localStorage.setItem(TENANT_TYPE_KEY, name);
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/storage.util.ts